import $ from 'jquery'

class KnowledgeSearch {
    constructor() {

        this.knowledgeSerchDiv = $('.knowledge-search');
        this.addSearchHTML();

        this.spinner = '<div class="knowledge-search__spinner"></div>';
        this.resetBtn = $('.knowledge-search__reset');
        this.isSpinnerVisible = false;
        this.searchField = $('#knowledge-search__input');
        this.resultsDiv = $('[data-knowledge-search="results"]');
        this.resetBtn = $('[data-knowledge-search="reset"]');
        this.previousValue;

        this.typingTimer;
        this.events();
    }

    // Events
    events() {
        this.searchField.on('keyup', this.typingLogic.bind(this))
        this.resetBtn.on('click', this.resetBtnHandler.bind(this))
    }

    // Methods
    typingLogic() {
        if (this.searchField.val() !== this.previousValue) {
            clearTimeout(this.typingTimer);

            if (this.searchField.val()) {
                this.resultsDiv.addClass('knowledge-search__results--active');
                this.resetBtn.addClass('knowledge-search__reset--active');
                if (!this.isSpinnerVisible) {

                    this.resultsDiv.html(this.spinner);
                    this.isSpinnerVisible = true;
                }
                this.typingTimer = setTimeout(this.getResults.bind(this), 750);
            } else {
                this.resultsDiv.html('');
                this.isSpinnerVisible = false;
                this.resultsDiv.removeClass('knowledge-search__results--active');
                this.resetBtn.removeClass('knowledge-search__reset--active');
            }


        }

        this.previousValue = this.searchField.val();
    }

    getResults() {
        /**
         * @var axData global obj from php
         * @var root_url string site url
         */
        $.when(
            $.getJSON(
                `${axData.root_url}/wp-json/wp/v2/posts?categories=531,30,24&filter[posts_per_page]=-1&search=${this.searchField.val()}`
            )
        ).then(
            posts => {
                this.resultsDiv.html(`
                ${posts.length ? '<ul class="knowledge-search__list">' : '<p class="knowledge-search__item">Публикаций не найдено.</p>'}
                    ${posts.map(item => `<li class="knowledge-search__item"><a class="knowledge-search__link" href="${item.link}">${item.title.rendered}</a></li>`).join(' ')}
                 ${posts.length ? '</ul>' : ''}
                `);
            },
            () => {
                this.resultsDiv.html('<p class="knowledge-search__item">Произошла ошибка, попробуйте ещё раз</p>')
            }
        )
        this.isSpinnerVisible = false;
    }

    addSearchHTML() {
        this.knowledgeSerchDiv.append(`
            <div class="knowledge-search__results" data-knowledge-search="results"></div>
        `);
    }

    resetBtnHandler() {
        this.searchField.val('');
        this.resultsDiv.html('').removeClass('knowledge-search__results--active');
        this.resetBtn.removeClass('knowledge-search__reset--active');
        this.searchField.focus();
    }
}

export default KnowledgeSearch;
